import { React } from "react";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import SingleMeetupPost from "./SingleMeetupPost";
import SingleLiveChatPost from "./SingleLiveChatPost";
import SingleQnA from "./SingleQnA";
import SingleLearningSession from "./SingleLearningSession";
import SingleFanGroup from "./SingleFanGroup";
import SingleAuditionPost from "./SingleAuditionPost";
import SingleGeneralPost from "./SingleGeneralPost";
import SingleGreetingPost from "./SingleGreetingPost";

export default function PostContent({ post, handleAllMuteToggle, allMuted, playerRef, volume, volumeChangeHandler }) {
  return (
    <>
      {post.type === "meetup" ? (
        <SingleMeetupPost post={post}></SingleMeetupPost>
      ) : post.type === "livechat" ? (
        <SingleLiveChatPost post={post}></SingleLiveChatPost>
      ) : post.type === "qna" ? (
        <SingleQnA post={post}></SingleQnA>
      ) : post.type === "learningSession" ? (
        <SingleLearningSession post={post}></SingleLearningSession>
      ) : post.type === "fangroup" ? (
        <SingleFanGroup post={post}></SingleFanGroup>
      ) : post.type === "audition" ? (
        <SingleAuditionPost post={post}></SingleAuditionPost>
      ) : post.type === "general" ? (
        <SingleGeneralPost post={post} handleAllMuteToggle={handleAllMuteToggle} volumeChangeHandler={volumeChangeHandler} allMuted={allMuted} playerRef={playerRef}  volume={volume}></SingleGeneralPost>
      ) : post.type === "greeting" ? (
        <SingleGreetingPost post={post}></SingleGreetingPost>
      ) : (
        ""
      )}
    </>
  );
}
